import { Typography } from 'components/Contentful'
import classNames from 'classnames'
import Heart from 'components/Svgs/Heart'
import Emblem from 'components/Svgs/Emblem'
import Champ from 'components/Svgs/Champ'
import { TAB_QUOTE_STYLE, LENDING_VARIANT } from './constants'

const EMBLEM_MAP = {
  Heart: Heart,
  Champ: Champ,
}

const BubbleComponent = ({ bubble, index }) => {
  if (bubble?.variation === TAB_QUOTE_STYLE) {
    const EmblemIcon = EMBLEM_MAP[bubble?.emblem] || Emblem
    return (
      <div className="absolute bottom-4 sm:bottom-8 left-1/2 transform -translate-x-1/2 w-[80%] md:w-[90%] xl:w-[78%] bg-white rounded-xl p-4 shadow-md flex flex-col gap-2">
        <div className="relative">
          <span className="inline md:block text-lg md:text-3xl text-gray-800 font-semibold">
            {'\u201C'}
          </span>
          <Typography
            className="inline md:block text-base lg:text-lg font-semibold text-[#1A1A1A] mt-1 leading-none"
            content={bubble?.text}
          />
          <Typography
            className="text-xs lg:text-sm text-gray-600 mt-2"
            content={bubble?.disclaimer}
          />
          {bubble?.emblem && (
            <div className="absolute top-2 right-0 lg:right-0 lg:top-0 lg:left-3/4 transform  -translate-y-14">
              <div className="w-12 h-12 lg:w-16 lg:h-16  flex items-center justify-center">
                <EmblemIcon />
              </div>
            </div>
          )}
        </div>
      </div>
    )
  }

  if (bubble?.variation === LENDING_VARIANT) {
    return (
      <div
        className="whitespace-nowrap py-[11px] px-2 md:py-2 md:px-3 absolute rounded-md border border-solid border-[#D2E2FE]
      bg-white top-[62%] sm:top-[75%] sm:left-[25%] xl:top-[74%] xl:left-[35%]
      "
        key={index}
        data-testid="bubble-variation-item-container"
      >
        <Typography
          content={bubble?.text}
          className="whitespace-normal m-auto text-sm md:text-base text-center"
        />
        <Typography
          content={bubble?.author}
          className="text-xs md:text-sm text-center text-[#5C708A]"
        />
      </div>
    )
  }

  return (
    <Typography
      key={index}
      className={classNames(
        'whitespace-nowrap py-[11px] px-3 md:py-2 md:px-3 absolute',
        bubble?.style
      )}
      content={bubble?.text}
      data-testid="bubble-item"
    />
  )
}

export { BubbleComponent }
